<template>
	<div class="flex flex-align-center mr-4">
        <rd-text :useByTable="false" width="65" label="店铺">{{ row['shop_name'] | formatEmpty }}</rd-text>
		<ID-tag label="店铺ID" :id="row.shop_id" />
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import IDTag from '@/components/ui/IDTag';
export default {
	mixins: [mixin],
    components:{
        IDTag
    }
};
</script>
